<template src='./new.pug' lang='pug'></template>

<script>
import vSelect from 'vue-select'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import FilterPortlet from '../../../layout/filterPortlet/FilterPortlet'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import customSorter from '../../../../utils/customSorter.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'OccurrenceReasonNew',

  components: {
    vSelect,
    PageTitle,
    FilterPortlet,
    ButtonPrimary
  },

  data () {
    return {
      requestSent: false,
      occurrenceReason: {
        id: null,
        initials: null,
        description: null,
        category: null
      },
      categories: []
    }
  },

  computed: {
    occurrenceReasonToEditId () {
      return this.$store.getters.occurrenceReasonToEditId
    },

    filterPortletTitle () {
      return this.occurrenceReasonToEditId ? this.$t('motivoOcorrencia.labels.editar')
        : this.$t('motivoOcorrencia.labels.novoPortlet')
    }
  },

  watch: {
    occurrenceReason: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, this.occurrenceReason))
      },
      deep: true
    }
  },

  methods: {
    setOcurrencyCategory (val) {
      setTimeout(() => {
        if (val) {
          if (!this.occurrenceReason.category) this.occurrenceReason.category = {}
          this.occurrenceReason.category.id = val.id
          this.occurrenceReason.category.nome = val.nome
          this.occurrenceReason.category.numero = val.numero
          this.occurrenceReason.category.label = val.numero + ' - ' + val.nome
        } else {
          this.occurrenceReason.category = null
        }
      }, 100)
    },

    loadCategories () {
      this.$store.dispatch('getCategories', {
        url: '/occurrenceReason/loadCategories',
        flTipoCategoria: 'A,C,D',
        validarUso: false
      }).then((response) => {
        let catArray = []
        response.data.forEach(cat => {
          cat.label = cat.numero + ' - ' + cat.nome
          catArray.push(cat)
        })
        // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'
        this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')
      }).catch((error) => {
        this.$root.$refs.notification.error(error.data.message)
      })
    },

    newOcurrencyReason () {
      let occur = {
        id: this.occurrenceReasonToEditId,
        codigo: this.occurrenceReason.initials,
        descricao: this.occurrenceReason.description,
        categoria: this.occurrenceReason.category
      }

      this.requestSent = true
      this.$store.dispatch('saveOccurrenceReason', occur)
        .then((response) => {
          if (this.occurrenceReasonToEditId) {
            this.$root.$refs.notification.success('motivoOcorrencia.sucesso.editar')
          } else {
            this.$root.$refs.notification.success('motivoOcorrencia.sucesso.criar')
          }
          this.$store.dispatch('setHasUnsavedChanges', false)
          this.$router.push(PATHS.LIST_OCCURRENCE_REASONS)
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
        .finally(() => {
          this.requestSent = false
        })
    },

    loadOccurrenceReason () {
      this.$store.dispatch('getOccurrenceReason', this.occurrenceReasonToEditId)
        .then((response) => {
          this.occurrenceReason.initials = response.data.data.codigo
          this.occurrenceReason.description = response.data.data.descricao
          this.occurrenceReason.category = response.data.data.categoria
          this.occurrenceReason.category.label = this.occurrenceReason.category.numero + ' - ' + this.occurrenceReason.category.nome
          this.defaultObject = { ...this.occurrenceReason, category: { ...this.occurrenceReason.category } }
        })
    },

    validate (event) {
      event.preventDefault()
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.newOcurrencyReason()
          } else {
            this.$root.$refs.notification.error('administracao.operadores.validacao.camposObrigatorios', 'motivoOcorrencia.erro.criar')
          }
        })
    },

    back () {
      this.$router.push(PATHS.LIST_OCCURRENCE_REASONS)
    }
  },

  created () {
    this.loadCategories()
    if (this.occurrenceReasonToEditId) {
      this.loadOccurrenceReason()
    } else {
      this.defaultObject = { ...this.occurrenceReason }
    }
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
    this.$store.dispatch('cleanOccurrenceReasonToEdit')
  }
}
</script>



// WEBPACK FOOTER //
// New.vue?986bc81a